<template>
  <div class="no-binding-store">
    <p>暂未绑定门店</p>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import './variables.scss';
.no-binding-store {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: calc(100vh - $tab-height);
  pointer-events: none;
  background: #fff;
  z-index: 2005;
}
</style>
